<template>
  <b-row :class="['priority-item p-2', { 'priority-item-editable': editable }]">
    <b-col class="d-flex align-items-center">
      <div>
        <component
          :is="doneIcon(priority)"
          font-scale="1.5"
          :class="{ 'priority-done': priority.isDone }"
          @click="$emit('toggle', priority)"
        />
      </div>
      <div class="pl-3 text-left" v-on="editable ? { click: onClick } : {}">{{priority.content}}</div>
    </b-col>
    <b-col v-if="deletable" cols="auto" class="priority-item-hover">
      <b-link class="btn-link-red" @click="$emit('delete', priority)">Delete</b-link>
    </b-col>
  </b-row>
</template>

<script>
import { BIconCheckCircleFill, BIconCircle } from 'bootstrap-vue'

export default {
  name: 'PriorityItem',

  props: {
    priority: {
      type: Object,
      required: true
    },

    editable: {
      type: Boolean,
      default: false
    },

    deletable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    doneIcon(priority) {
      return priority.isDone ? BIconCheckCircleFill : BIconCircle
    },

    onClick() {
      return this.$emit('edit', this.priority)
    }
  }
}
</script>
